import { DAY, MONTH, YEAR_PULLDOWN_DEFAULT_FROM } from 'models';
import {
  DateProperty,
  DatePropertyYearPulldown,
  DATE_PROPERTY_INPUT_TYPE,
  FormPageInputItem,
  FormPageInputItemDate,
  FormPageInputItemDateFree,
  FormPageInputItemDateYearPulldown,
  INPUT_ITEM_TYPE,
} from 'shared';

const handleFree = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemDateFree => {
  const inputItemType = INPUT_ITEM_TYPE.dateFree;
  if (formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.dateFree) {
    return {
      inputItemType,
      year: formPageInputItem.year || '',
      month: formPageInputItem.month || '',
      day: formPageInputItem.day || '',
    };
  }
  return {
    inputItemType,
    year: '',
    month: '',
    day: '',
  };
};

const isDateYearPulldown = (
  formPageInputItem?: FormPageInputItem
): formPageInputItem is FormPageInputItemDateYearPulldown =>
  formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.dateYearPulldown;

const getFrom = (
  showRange: DatePropertyYearPulldown['inputFormat']['showRange']
): string => {
  const from = showRange?.showYearFrom ?? YEAR_PULLDOWN_DEFAULT_FROM;
  return `${from}`;
};

const handleYearPulldown = (
  inputFormat: DatePropertyYearPulldown['inputFormat'],
  formPageInputItem?: FormPageInputItem
): FormPageInputItemDateYearPulldown => {
  const { showRange, unselectedState } = inputFormat;
  const inputItemType = INPUT_ITEM_TYPE.dateYearPulldown;
  if (unselectedState) {
    if (isDateYearPulldown(formPageInputItem)) {
      return {
        inputItemType,
        year: formPageInputItem.year || '',
        month: formPageInputItem.month || '',
        day: formPageInputItem.day || '',
      };
    }
    return {
      inputItemType,
      year: '',
      month: '',
      day: '',
    };
  }
  const from = getFrom(showRange);
  if (isDateYearPulldown(formPageInputItem)) {
    return {
      inputItemType,
      year: formPageInputItem.year || `${from}`,
      month: formPageInputItem.month || MONTH[0],
      day: formPageInputItem.day || DAY[0],
    };
  }
  return {
    inputItemType,
    year: `${from}`,
    month: MONTH[0],
    day: DAY[0],
  };
};

export const convertDateInitialValue = (
  property: DateProperty,
  formPageInputItem?: FormPageInputItem
): FormPageInputItemDate => {
  const { free, yearPulldown } = DATE_PROPERTY_INPUT_TYPE;
  switch (property.inputFormat.inputType) {
    case free: {
      return handleFree(formPageInputItem);
    }
    case yearPulldown:
      return handleYearPulldown(property.inputFormat, formPageInputItem);
  }
};
